import _objectWithoutProperties from "D:\\bosscar\\bosscarsoft16\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "D:\\bosscar\\bosscarsoft16\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "D:\\bosscar\\bosscarsoft16\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _defineProperty from "D:\\bosscar\\bosscarsoft16\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
var _excluded = ["disabled", "placeholder", "multiple", "search", "autoFocus", "autoComplete", "id", "closeOnSelect", "className", "renderValue", "renderOption", "renderGroupHeader", "fuzzySearch", "emptyMessage", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsxs as $6XpKT$jsxs, jsx as $6XpKT$jsx } from "react/jsx-runtime";
import { forwardRef as $6XpKT$forwardRef, useRef as $6XpKT$useRef, useState as $6XpKT$useState, useEffect as $6XpKT$useEffect, memo as $6XpKT$memo } from "react";
import "prop-types";
function $f63eea9d7c5f466f$export$2e2bcd8739ae039(v1, v2) {
  return String(v1) === String(v2);
}
function $f7a118348608ef0e$export$2e2bcd8739ae039(value, options) {
  if (Array.isArray(value)) return value.map(function (v) {
    return options.find(function (o) {
      return (0, $f63eea9d7c5f466f$export$2e2bcd8739ae039)(o.value, v);
    });
  }).filter(function (o) {
    return o;
  });
  return options.find(function (o) {
    return (0, $f63eea9d7c5f466f$export$2e2bcd8739ae039)(o.value, value);
  }) || null;
}
function $ab17a5af9c7227da$export$2e2bcd8739ae039(value) {
  return Array.isArray(value) ? value : [value];
}
function $fcc1d8b4a4fe77ec$export$2e2bcd8739ae039(newOption, oldOption, multiple) {
  if (!newOption) return oldOption;
  if (!multiple) return newOption;
  if (!oldOption) return (0, $ab17a5af9c7227da$export$2e2bcd8739ae039)(newOption);
  var nextOption = (0, $ab17a5af9c7227da$export$2e2bcd8739ae039)(oldOption);
  var newOptionIndex = nextOption.findIndex(function (o) {
    return (0, $f63eea9d7c5f466f$export$2e2bcd8739ae039)(o.value, newOption.value);
  });
  if (newOptionIndex >= 0) nextOption.splice(newOptionIndex, 1);else nextOption.push(newOption);
  return nextOption;
}
function $29242e7c542b89e5$export$2e2bcd8739ae039(option, options, placeholder) {
  if (!option && !placeholder) return options && options.length ? options[0].name || "" : "";
  var isMultiple = Array.isArray(option);
  if (!option && !isMultiple) return "";
  return isMultiple ? option.map(function (o) {
    return o.name;
  }).filter(Boolean).join(", ") : option.name || "";
}
function $8f7d71ac34985a60$export$2e2bcd8739ae039(option) {
  if (!option) return null;
  if (Array.isArray(option)) return option.filter(Boolean).map(function (o) {
    return o.value;
  });
  return option.value || null;
}
function $559302edb229d5e8$export$2e2bcd8739ae039(options) {
  var nextOptions = [];
  options.forEach(function (option) {
    if (option.group) {
      var group = nextOptions.findIndex(function (o) {
        return o.type === "group" && o.name === option.group;
      });
      if (group >= 0) nextOptions[group].items.push(option);else nextOptions.push({
        items: [option],
        type: "group",
        name: option.group
      });
    } else nextOptions.push(option);
  });
  return nextOptions;
}
function $e2eb089248fa8007$var$search(q, text) {
  var searchLength = q.length;
  var textLength = text.length;
  if (searchLength > textLength) return false;
  if (text.indexOf(q) >= 0) return true;
  mainLoop: for (var i = 0, j = 0; i < searchLength; i += 1) {
    var ch = q.charCodeAt(i);
    while (j < textLength) {
      if (text.charCodeAt(j++) === ch) continue mainLoop;
    }
    return false;
  }
  return true;
}
function $e2eb089248fa8007$export$2e2bcd8739ae039(options, query) {
  return !query.length ? options : options.filter(function (o) {
    return $e2eb089248fa8007$var$search(query.toLowerCase(), "".concat(o.name, " ").concat(o.group || "").trim().toLowerCase());
  });
}
function $5b742793c6607960$export$2e2bcd8739ae039(middleware, items, query) {
  return middleware.filter(Boolean).reduce(function (data, cb) {
    return cb(data, query);
  }, items).map(function (item, i) {
    return _objectSpread(_objectSpread({}, item), {}, {
      index: i
    });
  });
}
function $ab7b6b8f43adf325$export$2e2bcd8739ae039(options) {
  var index = 0;
  return options.map(function (option) {
    if (option.type === "group") return option.items.map(function (o) {
      return _objectSpread(_objectSpread({}, o), {}, {
        group: option.name,
        index: index++
      });
    });
    return _objectSpread(_objectSpread({}, option), {}, {
      index: index++
    });
  }).flat();
}
function $21775510bb0d6713$export$2e2bcd8739ae039(defaultOptions, getOptions, debounceTime, search) {
  var _ref = (0, $6XpKT$useState)(function () {
      return (0, $ab7b6b8f43adf325$export$2e2bcd8739ae039)(defaultOptions);
    }),
    _ref2 = _slicedToArray(_ref, 2),
    options = _ref2[0],
    setOptions = _ref2[1];
  var _ref3 = (0, $6XpKT$useState)(false),
    _ref4 = _slicedToArray(_ref3, 2),
    fetching = _ref4[0],
    setFetching = _ref4[1];
  (0, $6XpKT$useEffect)(function () {
    var timeout;
    if (!getOptions) return;
    timeout = setTimeout(function () {
      var optionsReq = getOptions(search, options);
      setFetching(true);
      Promise.resolve(optionsReq).then(function (newOptions) {
        return setOptions((0, $ab7b6b8f43adf325$export$2e2bcd8739ae039)(newOptions));
      }).finally(function () {
        return setFetching(false);
      });
    }, debounceTime);
    return function () {
      clearTimeout(timeout);
    };
  }, [search]);
  (0, $6XpKT$useEffect)(function () {
    setOptions((0, $ab7b6b8f43adf325$export$2e2bcd8739ae039)(defaultOptions));
  }, [defaultOptions]);
  return [options, fetching];
}
function $e86f7a275d5b9934$export$2e2bcd8739ae039(current, dir, options) {
  var max = options.length - 1;
  var option = null;
  var i = -1;
  var newHighlighted = current;
  while (i++ <= max && (!option || option.disabled)) {
    newHighlighted = dir === "down" ? newHighlighted + 1 : newHighlighted - 1;
    if (newHighlighted < 0) newHighlighted = max;else if (newHighlighted > max) newHighlighted = 0;
    option = options[newHighlighted];
  }
  return newHighlighted;
}
function $8c63ada902e0d18e$export$2e2bcd8739ae039(options, onSelect, ref) {
  var _ref5 = (0, $6XpKT$useState)(-1),
    _ref6 = _slicedToArray(_ref5, 2),
    highlighted = _ref6[0],
    setHighlighted = _ref6[1];
  return [{
    onKeyDown: function onKeyDown(e) {
      var key = e.key.replace("Arrow", "").toLowerCase();
      if (key === "down" || key === "up") {
        e.preventDefault();
        setHighlighted((0, $e86f7a275d5b9934$export$2e2bcd8739ae039)(highlighted, key, options));
      }
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === "Escape") {
        e.preventDefault();
        ref.current.blur();
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (options[highlighted]) onSelect(options[highlighted].value);
      }
    }
  }, highlighted, setHighlighted];
}
var $0d0f732c1d5a71da$var$nullCb = function $0d0f732c1d5a71da$var$nullCb() {};
function $0d0f732c1d5a71da$export$2e2bcd8739ae039(_ref7) {
  var defaultOptions = _ref7.options,
    defaultValue = _ref7.defaultValue,
    value = _ref7.value,
    multiple = _ref7.multiple,
    search = _ref7.search,
    _ref7$onChange = _ref7.onChange,
    onChange = _ref7$onChange === void 0 ? $0d0f732c1d5a71da$var$nullCb : _ref7$onChange,
    _ref7$onFocus = _ref7.onFocus,
    _onFocus = _ref7$onFocus === void 0 ? $0d0f732c1d5a71da$var$nullCb : _ref7$onFocus,
    _ref7$onBlur = _ref7.onBlur,
    _onBlur = _ref7$onBlur === void 0 ? $0d0f732c1d5a71da$var$nullCb : _ref7$onBlur,
    _ref7$closeOnSelect = _ref7.closeOnSelect,
    closeOnSelect = _ref7$closeOnSelect === void 0 ? true : _ref7$closeOnSelect,
    placeholder = _ref7.placeholder,
    getOptions = _ref7.getOptions,
    filterOptions = _ref7.filterOptions,
    _ref7$useFuzzySearch = _ref7.useFuzzySearch,
    useFuzzySearch = _ref7$useFuzzySearch === void 0 ? true : _ref7$useFuzzySearch,
    debounce = _ref7.debounce;
  var ref = (0, $6XpKT$useRef)();
  var _ref8 = (0, $6XpKT$useState)(null),
    _ref9 = _slicedToArray(_ref8, 2),
    option = _ref9[0],
    setOption = _ref9[1];
  var _ref10 = (0, $6XpKT$useState)(""),
    _ref11 = _slicedToArray(_ref10, 2),
    q = _ref11[0],
    setSearch = _ref11[1];
  var _ref12 = (0, $6XpKT$useState)(false),
    _ref13 = _slicedToArray(_ref12, 2),
    focus = _ref13[0],
    setFocus = _ref13[1];
  var _ref14 = (0, $21775510bb0d6713$export$2e2bcd8739ae039)(defaultOptions, getOptions, debounce, q),
    _ref15 = _slicedToArray(_ref14, 2),
    options = _ref15[0],
    fetching = _ref15[1];
  var onSelect = function onSelect(v) {
    var newOption = (0, $fcc1d8b4a4fe77ec$export$2e2bcd8739ae039)((0, $f7a118348608ef0e$export$2e2bcd8739ae039)(decodeURIComponent(v), options), option, multiple);
    if (value === undefined) setOption(newOption);
    onChange((0, $8f7d71ac34985a60$export$2e2bcd8739ae039)(newOption), newOption);
    setTimeout(function () {
      if (ref.current && closeOnSelect) ref.current.blur();
    }, 0);
  };
  var _ref16 = (0, $8c63ada902e0d18e$export$2e2bcd8739ae039)(options, onSelect, ref),
    _ref17 = _slicedToArray(_ref16, 3),
    keyHandlers = _ref17[0],
    highlighted = _ref17[1],
    setHighlighted = _ref17[2];
  var middleware = [useFuzzySearch ? (0, $e2eb089248fa8007$export$2e2bcd8739ae039) : null].concat(_toConsumableArray(filterOptions ? filterOptions : []));
  var snapshot = {
    search: q,
    focus: focus,
    option: option,
    value: (0, $8f7d71ac34985a60$export$2e2bcd8739ae039)(option),
    fetching: fetching,
    highlighted: highlighted,
    options: (0, $559302edb229d5e8$export$2e2bcd8739ae039)((0, $5b742793c6607960$export$2e2bcd8739ae039)(middleware, options, q)),
    displayValue: (0, $29242e7c542b89e5$export$2e2bcd8739ae039)(option, options, placeholder)
  };
  var valueProps = _objectSpread(_objectSpread({
    tabIndex: "0",
    readOnly: !search,
    placeholder: placeholder,
    value: focus && search ? q : snapshot.displayValue,
    ref: ref
  }, keyHandlers), {}, {
    onFocus: function onFocus(e) {
      setFocus(true);
      _onFocus(e);
    },
    onBlur: function onBlur(e) {
      setFocus(false);
      setSearch("");
      setHighlighted(-1);
      _onBlur(e);
    },
    onMouseDown: function onMouseDown(e) {
      if (focus) {
        e.preventDefault();
        ref.current.blur();
      }
    },
    onChange: search ? function (_ref18) {
      var target = _ref18.target;
      return setSearch(target.value);
    } : null
  });
  var optionProps = {
    tabIndex: "-1",
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      onSelect(e.currentTarget.value);
    }
  };
  (0, $6XpKT$useEffect)(function () {
    setOption((0, $f7a118348608ef0e$export$2e2bcd8739ae039)(value === undefined ? defaultValue : value, options));
  }, [value, options]);
  return [snapshot, valueProps, optionProps];
}
var $461fda4bde208857$var$isString = function $461fda4bde208857$var$isString(str) {
  return typeof str === "string";
};
var $461fda4bde208857$var$getClassName = function $461fda4bde208857$var$getClassName(str, className) {
  return $461fda4bde208857$var$isString(className) ? "".concat(className, "-").concat(str) : className[str];
};
function $461fda4bde208857$export$2e2bcd8739ae039(classNames, className) {
  if ($461fda4bde208857$var$isString(classNames)) return $461fda4bde208857$var$getClassName(classNames, className);
  return Object.entries(classNames).filter(function (_ref19) {
    var _ref20 = _slicedToArray(_ref19, 2),
      cls = _ref20[0],
      display = _ref20[1];
    return cls && display;
  }).map(function (_ref21) {
    var _ref22 = _slicedToArray(_ref21, 1),
      cls = _ref22[0];
    return $461fda4bde208857$var$getClassName(cls, className);
  }).join(" ");
}
function $9b55b4f5631730e8$var$Option(_ref23) {
  var optionProps = _ref23.optionProps,
    highlighted = _ref23.highlighted,
    selected = _ref23.selected,
    option = _ref23.option,
    cls = _ref23.cls,
    renderOption = _ref23.renderOption,
    disabled = _ref23.disabled;
  var props = _objectSpread(_objectSpread({}, optionProps), {}, {
    value: encodeURIComponent(option.value),
    disabled: disabled
  });
  var className = cls({
    option: true,
    "is-selected": selected,
    "is-highlighted": highlighted
  });
  return /*#__PURE__*/(0, $6XpKT$jsxs)("li", {
    className: cls("row"),
    role: "menuitem",
    "data-index": option.index,
    children: [renderOption && renderOption(props, option, {
      selected: selected,
      highlighted: highlighted
    }, className), !renderOption && /*#__PURE__*/(0, $6XpKT$jsx)("button", _objectSpread(_objectSpread({
      type: "button",
      className: className
    }, props), {}, {
      children: option.name
    }))]
  });
}
var $9b55b4f5631730e8$export$2e2bcd8739ae039 = /*#__PURE__*/(0, $6XpKT$memo)($9b55b4f5631730e8$var$Option);
function $b5eecf9f88e2d7ae$export$2e2bcd8739ae039(option, selectedOption) {
  if (!selectedOption) return false;
  return Array.isArray(selectedOption) ? selectedOption.findIndex(function (o) {
    return o.value === option.value;
  }) >= 0 : selectedOption.value === option.value;
}
function $1b5fcad01c07e709$var$Options(props) {
  var options = props.options,
    cls = props.cls,
    renderOption = props.renderOption,
    renderGroupHeader = props.renderGroupHeader,
    optionProps = props.optionProps,
    snapshot = props.snapshot,
    disabled = props.disabled;
  return /*#__PURE__*/(0, $6XpKT$jsx)("ul", {
    className: cls("options"),
    children: options.map(function (o) {
      if (o.type === "group") return /*#__PURE__*/(0, $6XpKT$jsx)("li", {
        role: "none",
        className: cls("row"),
        children: /*#__PURE__*/(0, $6XpKT$jsxs)("div", {
          className: cls("group"),
          children: [/*#__PURE__*/(0, $6XpKT$jsx)("div", {
            className: cls("group-header"),
            children: renderGroupHeader ? renderGroupHeader(o.name) : o.name
          }), /*#__PURE__*/(0, $6XpKT$jsx)($1b5fcad01c07e709$var$Options, _objectSpread(_objectSpread({}, props), {}, {
            options: o.items
          }))]
        })
      }, o.name);
      return /*#__PURE__*/(0, $6XpKT$jsx)((0, $9b55b4f5631730e8$export$2e2bcd8739ae039), {
        option: o,
        optionProps: optionProps,
        cls: cls,
        renderOption: renderOption,
        selected: (0, $b5eecf9f88e2d7ae$export$2e2bcd8739ae039)(o, snapshot.option),
        highlighted: snapshot.highlighted === o.index,
        disabled: o.disabled || disabled
      }, o.value);
    })
  });
}
var $1b5fcad01c07e709$export$2e2bcd8739ae039 = /*#__PURE__*/(0, $6XpKT$memo)($1b5fcad01c07e709$var$Options);
var $00d3317695af813e$var$SelectSearch = /*#__PURE__*/(0, $6XpKT$forwardRef)(function (_ref24, ref) {
  var disabled = _ref24.disabled,
    placeholder = _ref24.placeholder,
    multiple = _ref24.multiple,
    search = _ref24.search,
    autoFocus = _ref24.autoFocus,
    autoComplete = _ref24.autoComplete,
    id = _ref24.id,
    closeOnSelect = _ref24.closeOnSelect,
    className = _ref24.className,
    renderValue = _ref24.renderValue,
    renderOption = _ref24.renderOption,
    renderGroupHeader = _ref24.renderGroupHeader,
    fuzzySearch = _ref24.fuzzySearch,
    emptyMessage = _ref24.emptyMessage,
    value = _ref24.value,
    hookProps = _objectWithoutProperties(_ref24, _excluded);
  var selectRef = (0, $6XpKT$useRef)(null);
  var cls = function cls(classNames) {
    return (0, $461fda4bde208857$export$2e2bcd8739ae039)(classNames, className);
  };
  var _ref25 = (0, $6XpKT$useState)(value),
    _ref26 = _slicedToArray(_ref25, 2),
    controlledValue = _ref26[0],
    setControlledValue = _ref26[1];
  var _ref27 = (0, $0d0f732c1d5a71da$export$2e2bcd8739ae039)(_objectSpread({
      value: controlledValue,
      placeholder: placeholder,
      multiple: multiple,
      search: search,
      closeOnSelect: closeOnSelect && !multiple,
      useFuzzySearch: fuzzySearch
    }, hookProps)),
    _ref28 = _slicedToArray(_ref27, 3),
    snapshot = _ref28[0],
    valueProps = _ref28[1],
    optionProps = _ref28[2];
  var highlighted = snapshot.highlighted,
    snapValue = snapshot.value,
    fetching = snapshot.fetching,
    focus = snapshot.focus;
  var props = _objectSpread(_objectSpread({}, valueProps), {}, {
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    disabled: disabled
  });
  (0, $6XpKT$useEffect)(function () {
    var current = selectRef.current;
    if (current) {
      var val = Array.isArray(snapValue) ? snapValue[0] : snapValue;
      var selected = current.querySelector(highlighted > -1 ? "[data-index=\"".concat(highlighted, "\"]") : "[value=\"".concat(encodeURIComponent(val), "\"]"));
      if (selected) {
        var rect = current.getBoundingClientRect();
        var selectedRect = selected.getBoundingClientRect();
        current.scrollTop = selected.offsetTop - rect.height / 2 + selectedRect.height / 2;
      }
    }
  }, [snapValue, highlighted, selectRef.current]);
  (0, $6XpKT$useEffect)(function () {
    return setControlledValue(value);
  }, [value]);
  return /*#__PURE__*/(0, $6XpKT$jsxs)("div", {
    ref: ref,
    id: id,
    className: cls({
      container: true,
      "is-multiple": multiple,
      "is-disabled": disabled,
      "is-loading": fetching,
      "has-focus": focus
    }),
    children: [(!multiple || placeholder || search) && /*#__PURE__*/(0, $6XpKT$jsxs)("div", {
      className: cls("value"),
      children: [renderValue && renderValue(props, snapshot, cls("input")), !renderValue && /*#__PURE__*/(0, $6XpKT$jsx)("input", _objectSpread(_objectSpread({}, props), {}, {
        className: cls("input")
      }))]
    }), /*#__PURE__*/(0, $6XpKT$jsxs)("div", {
      className: cls("select"),
      ref: selectRef,
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      },
      children: [snapshot.options.length > 0 && /*#__PURE__*/(0, $6XpKT$jsx)((0, $1b5fcad01c07e709$export$2e2bcd8739ae039), {
        options: snapshot.options,
        optionProps: optionProps,
        renderOption: renderOption,
        renderGroupHeader: renderGroupHeader,
        disabled: disabled,
        snapshot: snapshot,
        cls: cls
      }), !snapshot.options.length && /*#__PURE__*/(0, $6XpKT$jsx)("ul", {
        className: cls("options"),
        children: !snapshot.options.length && emptyMessage && /*#__PURE__*/(0, $6XpKT$jsx)("li", {
          className: cls("not-found"),
          children: emptyMessage
        })
      })]
    })]
  });
});
$00d3317695af813e$var$SelectSearch.defaultProps = {
  // Data
  options: [],
  fuzzySearch: true,
  // Interaction´
  printOptions: "auto",
  closeOnSelect: true,
  debounce: 250,
  // Attributes
  autoComplete: "on",
  // Design
  className: "select-search"
};
$00d3317695af813e$var$SelectSearch.displayName = "SelectSearch";
var $00d3317695af813e$export$2e2bcd8739ae039 = /*#__PURE__*/(0, $6XpKT$memo)($00d3317695af813e$var$SelectSearch);
var $cf838c15c8b009ba$export$2e2bcd8739ae039 = (0, $00d3317695af813e$export$2e2bcd8739ae039);
export { $cf838c15c8b009ba$export$2e2bcd8739ae039 as default, $0d0f732c1d5a71da$export$2e2bcd8739ae039 as useSelect };